export default __webpack_public_path__ + "static/media/DinosaursFossilHunters_00.52e78686.png";